import { render, staticRenderFns } from "./AttachmentItemImageMode.vue?vue&type=template&id=b596847e&scoped=true"
import script from "./AttachmentItemImageMode.vue?vue&type=script&lang=ts"
export * from "./AttachmentItemImageMode.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentItemImageMode.vue?vue&type=style&index=0&id=b596847e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b596847e",
  null
  
)

export default component.exports